<template>
  <div>
    <md-dialog :md-active.sync="show"
               :md-fullscreen="false"
               :md-click-outside-to-close="false"
               :md-close-on-esc="false">

      <md-dialog-content class="mt-3 mb-3">

        <div class="text-right">
          <div @click="confirm(data)">
            <img class="img-fluid icon-close" src="../assets/images/close.png">
          </div>
        </div>

        <div class="message" v-html="dialog.message"></div>


        <div class="text-right">
          <div class="button-yellow" @click="confirm(data)">
            ปิด
          </div>
        </div>

      </md-dialog-content>


    </md-dialog>
  </div>
</template>

<script>
export default {
  name: 'DialogPolicy',
  props: {
    dialog: Object,
    show: Boolean,
    data: Object
  },
  methods: {
    confirm: function (value) {
      this.$emit('close', value);
    }
  }
}
</script>


<style scoped lang="scss">
@import "../assets/css/colors";

.md-dialog {
  color: $navy !important;
}

.icon-close{
  max-height: 25px;
  cursor: pointer;
}
</style>
